module.exports = __webpack_public_path__ + "static/media/faq.0d89a0c5.jpg";